const SA_NATIVE_TRANSFER_GAS_USED = 12000n
const SA_ERC20_TRANSFER_GAS_USED = 18000n
const GAS_TANK_TRANSFER_GAS_USED = 5000n

// ZKX: overhead the RELAYER broadcast path under-estimates. The deployless
// Estimation contract measures execution in a sender context (no signature
// check), but the relayer broadcasts AmbireAccount.execute(calls, signature),
// which additionally pays for the on-chain EIP-712 signature verification
// (domain + AmbireOperation hashing + ecrecover) and the execute() wrapper.
// Upstream's relayer tolerates the gap by debiting the observed on-chain cost;
// the ZKX relayer simulates AND broadcasts at exactly this gasLimit and rejects
// an under-estimate as out-of-gas, so the byRelayer branch must add it back —
// mirroring the byBundler branch, which already adds the components upstream
// omits. Measured gap on a PulseChain gas-tank spend was ~15.6k gas
// (estimate 56,677 vs eth_estimateGas 72,314); 25k covers it with headroom, and
// an over-estimate is safe (slightly higher fee, still broadcasts).
const RELAYER_EXECUTE_SIG_OVERHEAD_GAS = 25000n

// ZKX: extra gas-price buffer for the RELAYER fee amount. The fee is priced at
// the speed-increased gas price (fast = base +10%), but the ZKX relayer's
// executor re-checks the reserved fee against the LIVE gas price plus its own
// margin (15%) at broadcast time and refuses to broadcast an under-covered op
// ("reserved … < required … at live gas"). On a volatile chain like PulseChain
// (gas measured ~400,000 gwei, swinging fast) the +10% speed bump does not cover
// the relayer margin plus the drift between signing and broadcast, so a fair-at-
// signing fee is rejected. This buffer lifts the fee's gas price enough to clear
// live gas + the relayer margin with headroom. The gas-tank fee is small in USD,
// so the over-estimate costs a fraction of a cent while making the broadcast
// reliable. Applied ONLY to the relayer fee amount, not the broadcast gas price
// (the executor broadcasts at its own live price).
const RELAYER_FEE_GAS_PRICE_BUFFER_BPS = 3000n // +30%

// ZKX: re-measure large RELAYER gas limits after signing. The deployless
// Estimation contract answers an out-of-gas retry in coarse steps (1.05x, then
// 2.1x / 2.625x / 3.15x of the measured gas), so a deep DEX route (a 9-hop Piteas
// swap on PulseChain burns ~1.3-2.5M) comes back at 3-5M. The gas-tank relayer
// rejects anything above its 3M ceiling and reserves the fee for the whole
// limit (Trello #517). Once the op is signed, eth_estimateGas on the exact
// execute(calls, signature) the relayer broadcasts gives the real figure; the
// gasLimit is not part of the signed payload, so it can be lowered safely.
// Only limits above the threshold are re-measured — small ops keep their
// already-proven path and skip the extra RPC round-trip.
const RELAYER_GAS_LIMIT_REMEASURE_THRESHOLD = 1_000_000n
// Headroom over eth_estimateGas for state drift between submit and broadcast
// (pool reserves move, a route leg takes a different branch). eth_estimateGas
// already returns the minimum limit that succeeds (refunds and the 63/64 rule
// included — ~1.3x gasUsed on these swaps). Measured on this account's past
// PulseChain swaps: limits of 1.05-1.3x that minimum all executed, while the
// Estimation-derived limits for the two largest (3.24M / 3.13M) would now be
// rejected by the 3M ceiling; +15% puts them at 2.80M / 2.70M.
const RELAYER_REMEASURED_GAS_BUFFER_BPS = 1500n // +15%
const RELAYER_GAS_LIMIT_REMEASURE_TIMEOUT_MS = 8000

export {
  RELAYER_GAS_LIMIT_REMEASURE_THRESHOLD,
  RELAYER_REMEASURED_GAS_BUFFER_BPS,
  RELAYER_GAS_LIMIT_REMEASURE_TIMEOUT_MS,
  SA_NATIVE_TRANSFER_GAS_USED,
  SA_ERC20_TRANSFER_GAS_USED,
  GAS_TANK_TRANSFER_GAS_USED,
  RELAYER_EXECUTE_SIG_OVERHEAD_GAS,
  RELAYER_FEE_GAS_PRICE_BUFFER_BPS
}
